import React, {
  Component,
  KeyboardEventHandler,
  memo,
  useCallback,
  useEffect,
} from "react";

import CreatableSelect from "react-select/creatable";
import { ActionMeta, OnChangeValue } from "react-select";

const components = {
  DropdownIndicator: null,
};

const TRIGER_END = ["Enter", "Tab", ",", " "];

interface Option {
  label: string;
  value: string;
}

const createOption = (label: string) => ({
  label,
  value: label,
});

interface SelectSeperatedProps {
  values: OnChangeValue<Option, true>;
  onChange: (value: OnChangeValue<Option, true>) => void;
}

const SelectSeperated = ({ onChange, values }: SelectSeperatedProps) => {
  const [inputValue, setInputValue] = React.useState("");
  const handleChange = useCallback(
    (value: OnChangeValue<Option, true>, actionMeta: ActionMeta<Option>) => {
      onChange(value);
    },
    [inputValue, values]
  );

  const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = useCallback(
    (event) => {
      if (!inputValue) return;
      console.log(event.key);
      if (
        TRIGER_END.includes(event.key) &&
        values.filter((x) => inputValue.search(x.value) !== -1).length === 0
      ) {
        setInputValue("");
        onChange([...values, createOption(inputValue)]);
        event.preventDefault();
      } else if (
        values.filter((x) => inputValue.search(x.value) !== -1).length > 0
      ) {
        setInputValue("");
        onChange([...values]);
      }
    },
    [values, inputValue]
  );

  return (
    <CreatableSelect
      components={components}
      inputValue={inputValue}
      isClearable
      isMulti
      menuIsOpen={false}
      onChange={handleChange}
      onInputChange={(x) => {
        setInputValue(x);
      }}
      onKeyDown={handleKeyDown}
      placeholder="Type something and press enter..."
      value={values}
    />
  );
};

export default memo(SelectSeperated);
